export default "__VITE_ASSET__BDQiEhTQ__"